function r(n) {
  var e = n.parentElement,
      l = null;

  for (; e && !(e instanceof HTMLFieldSetElement);) {
    e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
  }

  var t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return t && i(l) ? !1 : t;
}

function i(n) {
  if (!n) return !1;
  var e = n.previousElementSibling;

  for (; e !== null;) {
    if (e instanceof HTMLLegendElement) return !1;
    e = e.previousElementSibling;
  }

  return !0;
}

export { r as isDisabledReactIssue7711 };